import {
  Box,
  FileEarmark,
  FileEarmarkCode,
  FileEarmarkPdf,
  FileEarmarkPpt,
  FileEarmarkText,
  FileEarmarkWord,
  FileEarmarkZip,
  FiletypeXml,
  Folder2,
  Image,
} from "react-bootstrap-icons";

const extensionIcons = [
  {
    extensions: [".png", ".jpg", ".jpeg", ".gif", ".bmp", ".svg"],
    icon: (size: number | string | undefined) => <Image size={size} />,
  },
  {
    extensions: [".html"],
    icon: (size: number | string | undefined) => (
      <FileEarmarkCode size={size} />
    ),
  },
  {
    extensions: [".pdf"],
    icon: (size: number | string | undefined) => <FileEarmarkPdf size={size} />,
  },
  {
    extensions: [".zip"],
    icon: (size: number | string | undefined) => <FileEarmarkZip size={size} />,
  },
  {
    extensions: [".doc", ".docx"],
    icon: (size: number | string | undefined) => (
      <FileEarmarkWord size={size} />
    ),
  },
  {
    extensions: [".txt"],
    icon: (size: number | string | undefined) => (
      <FileEarmarkText size={size} />
    ),
  },
  {
    extensions: [".dwg", ".dxf"],
    icon: (size: number | string | undefined) => <Box size={size} />,
  },
  {
    extensions: [".xml"],
    icon: (size: number | string | undefined) => <FiletypeXml size={size} />,
  },
  {
    extensions: [".pptx", ".ppt"],
    icon: (size: number | string | undefined) => <FileEarmarkPpt size={size} />,
  },
];

interface FileIconProps {
  filename: string;
  isDirectory: boolean;
  size?: number | string;
}

function FileIcon({ filename, isDirectory, size }: FileIconProps) {
  if (isDirectory) return <Folder2 size={size} />;

  const extensionIndex = filename.lastIndexOf(".");

  if (extensionIndex >= 0) {
    const extension = filename.substring(extensionIndex).toLowerCase();

    for (let ii = 0; ii < extensionIcons.length; ++ii) {
      var matchIndex = extensionIcons[ii].extensions.indexOf(extension);

      if (matchIndex >= 0) return extensionIcons[ii].icon(size);
    }
  }

  return <FileEarmark size={size} />;
}

export default FileIcon;
